export const PublicFooter = () => (
  <footer
    data-testid="public-footer"
    className="border-t border-[#e5e1d8] mt-24 py-12 bg-[#f2efe9]"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-10 flex flex-col sm:flex-row gap-4 sm:gap-0 items-start sm:items-center justify-between">
      <div className="font-serif text-2xl tracking-widest text-[#1a1918]">ATTRAVERSANDO</div>
      <div className="font-sans text-xs tracking-[0.2em] uppercase text-[#4a4843]">
        diario · pensieri · attraversamenti
      </div>
    </div>
  </footer>
);

export default PublicFooter;
